/**
 * @module store/promocodes/getters
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


/**
 * Getter: Возвращает массив промокодов (текущую "страницу")
 *
 * @returns {array}
 */
const promocodes = state => state.promocodes;


/**
 * Getter: Возвращает общее число стартов
 *
 * @returns {number}
 */
const promocodesCount = state => state.total;


/**
 * Getter: Возвращает флаг, загружаются ли в текущий момент страница со стартами
 *
 * @returns {boolean}
 */
const isPromocodesLoading = state => state.isLoading;


export default {
  promocodes,
  promocodesCount,
  isPromocodesLoading,
};
